<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="!force && $emit('close')">
        <div class="modal-container" :class="{'small': small, 'xsmall' : xsmall, 'auto' : auto }">
          
          <slot name="header">
            <div class="button-tray" v-if="!force">
              <button class="btn close" @click="$emit('close')">&times;</button>
            </div>
          </slot>

          <div class="modal-body">
            <slot name="body" />
          </div>

          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  props: {
    force: { default: false, type: Boolean },
    small: { default: false, type: Boolean },
    xsmall: { default: false, type: Boolean },
    auto: { default: false, type: Boolean }
  },
  mounted() {
    document.body.classList.add('overflow-hidden');
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden');
  }
};
</script>